import {Action} from '@reduxjs/toolkit'
import {IRoleState, RoleModel} from '../models/Role'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  RolesRequested: '[Request Roles] Action',
  RolesLoaded: '[Load Roles] Roles API',
  RolesFailed: '[Load Roles] Roles API Failed',
  RoleRequested: '[Request Role] Action',
  RoleLoaded: '[Load Role] Role API',
  RoleFailed: '[Load Role] Role API Failed',
  RoleCreated: '[Create Role] Action',
  RoleUpdated: '[Update Role] Action',
  RoleDeleted: '[Delete Role] Action',
}

const initialRoleState: IRoleState = {
  roles: [],
  role: undefined,
  loading: false,
  error: undefined,
}


export const reducer = (state: IRoleState = initialRoleState, action: ActionWithPayload<IRoleState>) => {
  switch (action.type) {
    case actionTypes.RolesRequested: {
      return {...state, loading: true, error: undefined}
    }

    case actionTypes.RolesLoaded: {
      const roles = action.payload?.roles || []
      return {...state, roles, loading: false, error: undefined}
    }

    case actionTypes.RolesFailed: {
      const error = action.payload?.error
      return {...state, loading: false, error}
    }

    case actionTypes.RoleRequested: {
      return {...state, loading: true, error: undefined}
    }

    case actionTypes.RoleLoaded: {
      const role = action.payload?.role
      return {...state, role, loading: false, error: undefined}
    }

    case actionTypes.RoleFailed: {
      const error = action.payload?.error
      return {...state, loading: false, error}
    }

    case actionTypes.RoleCreated: {
      const role = action.payload?.role
      if (role) {
        return {...state, roles: [...state.roles, role], loading: false}
      }
      return state
    }

    case actionTypes.RoleUpdated: {
      const role = action.payload?.role
      if (role) {
        const updatedRoles = state.roles.map(r => (r.id === role.id ? role : r))
        return {...state, roles: updatedRoles, role, loading: false}
      }
      return state
    }

    case actionTypes.RoleDeleted: {
      const roleId = action.payload?.role?.id
      if (roleId) {
        const filteredRoles = state.roles.filter(r => r.id !== roleId)
        return {...state, roles: filteredRoles, loading: false}
      }
      return state
    }

    default:
      return state
  }
}

export const actions = {
  requestRoles: () => ({
    type: actionTypes.RolesRequested,
  }),
  fulfillRoles: (roles: RoleModel[]) => ({
    type: actionTypes.RolesLoaded,
    payload: {roles},
  }),
  failRoles: (error: string) => ({
    type: actionTypes.RolesFailed,
    payload: {error},
  }),
  requestRole: () => ({
    type: actionTypes.RoleRequested,
  }),
  fulfillRole: (role: RoleModel) => ({
    type: actionTypes.RoleLoaded,
    payload: {role},
  }),
  failRole: (error: string) => ({
    type: actionTypes.RoleFailed,
    payload: {error},
  }),
  createRole: (role: RoleModel) => ({
    type: actionTypes.RoleCreated,
    payload: {role},
  }),
  updateRole: (role: RoleModel) => ({
    type: actionTypes.RoleUpdated,
    payload: {role},
  }),
  deleteRole: (role: RoleModel) => ({
    type: actionTypes.RoleDeleted,
    payload: {role},
  }),
}













